module.exports = __webpack_public_path__ + "static/img/dd-partner-10.d279f40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-partner-10.jpg
// module id = V0wU
// module chunks = 1